<template>
  <div class="py-4 container-fluid">
    <!-- <a class="btn btn-sm btn-success" style="margin-right: 10px;" :href="apiUrl+'export-excel/daily-activity?project_type='+search.project_type+'&po_number='+search.po_number+'&c_date='+search.c_date+'&client='+search.client+'&owner='+search.owner+'&site='+search.site+'&kinds='+search.kinds+'&due_date='+search.due_date+''" target="_BLANK"><i class="fa fa-file-excel-o"></i> Export to Excel</a>
    <a class="btn btn-sm btn-primary" style="margin-right: 10px;" :href="apiUrl+'print-pdf/daily-activity?project_type='+search.project_type+'&po_number='+search.po_number+'&c_date='+search.c_date+'&client='+search.client+'&owner='+search.owner+'&site='+search.site+'&kinds='+search.kinds+'&due_date='+search.due_date+''" target="_BLANK"><i class="fa fa-file-pdf-o"></i> Export to PDF</a> -->

    <!-- CHART BAR DATA -->
    <div class="card mb-3"> 
      <div class="card-header pb-0 text-center align-content-center justify-content-center">
        <div class="row">
          <div class="col-12">
            <h6 class="text-center">CHART PRODUCTION METRIC TONS</h6>
          </div>
        </div>
      </div>
      <div class="card-body mt-n3">
        <div class="pt-3 chart">
          <canvas id="chart-line" class="chart-canvas" height="250"></canvas>
        </div>
      </div>
    </div>
    
    <div class=" row">
      <div class="col-12">
          <div class="card"> 
            <div class="row">
              <div class="col-lg-4">
                <div class="card-header pb-0">
                  <h6>Production Timeline</h6>
                </div>
              </div>
              <div class="col-lg-4">
              </div>
              <div class="col-lg-4 float-right">
               <!--  <argon-button
                  style="margin-right: 10px; margin-left: 60px;"
                  class="mt-4"
                  variant="gradient"
                  color="secondary"
                  size="sm"
                  @click="filter()"
                ><i class="fa fa-filter fa-sm" aria-hidden="true"></i> Filter</argon-button> -->
                <argon-button
                  class="mt-4"
                  variant="gradient"
                  color="success"
                  size="sm"
                  @click="create()"
                ><i class="fa fa-plus fa-sm" aria-hidden="true"></i> Add New</argon-button>
              </div>
            </div>
            
            <div class="card-body px-0 pt-0 pb-2 mt-4">
              <div class="table-responsive p-0 scroll">
                <table class="table table-hover table-bordered align-items-center mb-0">
                  <thead>
                    <tr>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">Client</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">Phase</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" v-for="month in months" :key="month">{{ month }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="(phases, client) in productionData">
                      <template v-for="(phaseName, index) in Object.keys(phases)" :key="index">
                        <tr>
                          <!-- Tampilkan client hanya di baris pertama dengan rowspan -->
                          <template v-if="index === 0">
                            <td class="text-secondary text-xs font-weight-bold" :rowspan="Object.keys(phases).length">{{ client }}</td>
                          </template>

                          <td class="text-secondary text-xs font-weight-bold">{{ phaseName }}</td>
                          <td class="text-xs font-weight-bold text-center" v-for="mon in months" :key="mon" :style="(phases[phaseName][mon]?.[2]) ? 'cursor: pointer; background-color:'+phases[phaseName][mon]?.[2] : '' " @click="edit(phases[phaseName][mon]?.[0])">
                            {{ phases[phaseName][mon]?.[1] || '' }}
                          </td>
                        </tr>
                      </template>
                    </template>
                    <!-- TOTAL ROW -->
                    <tr style="font-weight: ; background-color: #f0f0f0;">
                      <td colspan="2">TOTAL</td>
                      <td class="text-center" v-for="month in months" :key="'total-' + month">
                        {{ getTotal(month) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="card-footer">
              <div class="float-right">
                <!-- <span class="font-weight-bold text-danger ">TOTAL WORKING HOUR : {{ totalWorkingHour }} Hour {{ totalWorkingMinutes }} Minutes</span> -->
              </div>
              <div class="float-right">
                <!-- <base-pagination :page-count="pagination.page_count" :value="pagination.page" @input="changePage" :total="pagination.page_count" class="justify-content-end"></base-pagination> -->
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>

  <!-- =======  MODAL ADD DATA ======= -->
  <div class="container">
    <vue-final-modal v-model="form.show" classes="modal-container" content-class="modal-content" :z-index="10000">
      <!-- header -->
      <div class="row">
        <div class="col-11 float-left">
          <span class="modal__title">{{form.title}}</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="form.show = false"></i>
        </div>
      </div><hr>
      <!-- end header -->
      <div class="modal__content container">
        <label for="example-text-input" class="form-control-label mt-3">Client <span style="color: red;">*</span></label>
        <input type="text" class="form-control" placeholder="Client" v-model="timelineData.client">
        <label for="example-text-input" class="form-control-label mt-3">Phase <span style="color: red;">*</span></label>
        <input type="text" class="form-control" placeholder="Phase" v-model="timelineData.phase">
        <label for="example-text-input" class="form-control-label mt-3">Month <span style="color: red;">*</span></label>
        <select class="form-select" aria-label="Default select example" v-model="timelineData.production_month">
          <option value="1">January</option>
          <option value="2">February</option>
          <option value="3">March</option>
          <option value="4">April</option>
          <option value="5">May</option>
          <option value="6">June</option>
          <option value="7">Juli</option>
          <option value="8">August</option>
          <option value="9">September</option>
          <option value="10">October</option>
          <option value="11">November</option>
          <option value="12">December</option>
        </select>
        <label for="example-text-input" class="form-control-label mt-3">Year <span style="color: red;">*</span></label>
        <select class="form-select" aria-label="Default select example" v-model="timelineData.production_year">
          <option value="2024">2024</option>
          <option value="2025">2025</option>
          <option value="2026">2026</option>
          <option value="2027">2027</option>
          <option value="2028">2028</option>
        </select>
        <label for="example-text-input" class="form-control-label mt-3">Metric Tons <span style="color: red;">*</span></label>
        <input type="number" class="form-control" placeholder="Metric Tons" v-model="timelineData.production_mt">
         <label for="example-text-input" class="form-control-label mt-3">Mark Color <span style="color: red;">*</span></label>
        <select class="form-select" aria-label="Default select example" v-model="timelineData.mark_color">
          <option value="#7FFF00" style="background-color: #7FFF00;">GEEN</option>
          <option value="#FFD700" style="background-color: #FFD700;">GOLD</option>
          <option value="#87CEFA" style="background-color: #87CEFA;">BLUE</option>
          <option value="#FFB6C1" style="background-color: #FFB6C1;">PINK</option>
          <option value="#F5DEB3" style="background-color: #F5DEB3;">ORANGE</option>
        </select>
        <label for="example-text-input" class="form-control-label mt-3">Send Notification </label>
        <multiselect v-model="emailTo" :options="tableEmail.data" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Select Email" label="email" track-by="email" :preselect-first="false">
          <slot name="selection"><slot name="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length" v-show="!isOpen">{{ values.length }} options selected</span></slot></slot>
        </multiselect>
      </div>
      <!-- footer -->
      <div class="row float-right mt-5">
        <div class="col-lg-4"> 
        </div>
        <div class="col-lg-3" style="margin-right: 20px;">
         <!--  <argon-button  variant="gradient" color="danger" size="sm" width="1" @click="remove(row.id), form.show = true">
            <i class="fa fa-trash fa-sm" aria-hidden="true"></i> Delete
          </argon-button> -->
          <button type="success" class="btn btn-sm btn-danger btn-fill" @click="remove(timelineData.id)" :disabled="onLoading">
            <span>
                <span style="white-space: nowrap;"><i class="fa fa-trash fa-sm" aria-hidden="true" style="margin-right: 10px;"></i> Delete</span>
            </span>
          </button>
        </div>
        <div class="col-lg-2">
          <button type="success" class="btn btn-sm btn-success btn-fill" @click="save()" :disabled="onLoading">
            <span v-if="onLoading"><i class="fa fa-spinner fa-spin"></i> Please Wait...</span>
            <span v-else>
                <span style="white-space: nowrap;"><i class="fa fa-paper-plane" aria-hidden="true" style="margin-right: 10px;"></i> Save</span>
            </span>
          </button>
        </div>
      </div>
      <!-- end footer -->
    </vue-final-modal>
   </div>

  <!-- =======  MODAL FILTER ======= -->
  <div class="container">
    <vue-final-modal v-model="formFilter.show" classes="modal-container" content-class="modal-content" :z-index="10000">
      <!-- header -->
      <div class="row">
        <div class="col-11 float-left">
          <span class="modal__title">{{formFilter.title}}</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formFilter.show = false"></i>
        </div>
      </div><hr>
      <!-- end header -->
      <div class="modal__content container">
        <label for="example-text-input" class="form-control-label mt-3">Code </label>
        <input type="text" class="form-control" placeholder="Code" v-model="search.material_group_code" v-on:keyup.enter="get()">
        <label for="example-text-input" class="form-control-label mt-3">Material / Services Name </label>
        <input type="text" class="form-control" placeholder="Material / Services Name" v-model="search.group_name" v-on:keyup.enter="get()">
        <label for="example-text-input" class="form-control-label mt-3">Description </label>
        <input type="text" class="form-control" placeholder="Description" v-model="search.description" v-on:keyup.enter="get()">

        <!-- <label for="example-text-input" class="form-control-label mt-3">Date Range</label>
        <flat-pickr :config="{ mode: 'range',}" class="form-control" v-model="search.date"/> -->
      </div>
      <!-- footer -->
      <div class="row float-right mt-3">
        <div class="col-4"> 
        </div>
        <div class="col-3" style="margin-right: 20px;">
          <argon-button  variant="gradient" color="secondary" size="sm" width="1" @click="search = {}">Clear</argon-button>
        </div>
        <div class="col-2">
          <argon-button variant="gradient" color="success" size="sm" width="1" @click="get()">Filter</argon-button>
        </div>
      </div>
      <!-- end footer -->
    </vue-final-modal>
   </div>

</template>

<script>
// import Card from "@/examples/Cards/Card.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import { VueFinalModal } from 'vue-final-modal'
import Api from '@/helpers/api';
import config from '@/configs/config';
import { toast } from 'vue3-toastify';
// import Multiselect from 'vue-multiselect'
import 'vue3-toastify/dist/index.css';
// import flatPickr from 'vue-flatpickr-component';
// import 'flatpickr/dist/flatpickr.css';
// import ArgonProgress from "@/components/ArgonProgress.vue";
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.css';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'
import Chart from "chart.js/auto";
// import BasePagination from "@/components/BasePagination";
var moment = require('moment');
import productionTimeline from '@/services/production/productionTimeline.service';


export default {
  name: "tables",
  components: {
    // Card,
    ArgonButton,
    VueFinalModal,
    // Multiselect,
    // flatPickr,
    // ArgonProgress,
    Multiselect,
    // BasePagination
  },
  data() {
    return {
      pagination: {
        page_count: '',
        page: 1,
      },
      moment:moment,
      table: {
        data: []
      },
      tableProject: {
        data: []
      },
      tableActivity: {
        data: []
      },
      tableGroup: {
        data: []
      },
      tableEmployee: {
        data: []
      },
      form: {
        add: true,
        title: "Add Data",
        show: false
      },
      formImport: {
        add: true,
        title: "Import Data Setting Approval",
        show: false
      },
      formFilter: {
        add: true,
        title: "Filter",
        show: false
      },
      dataImport: '',
      onLoading: false,
      tabelError: {
        data: []
      },
      storageUrl : config.storageUrl,
      timelineData: {},
      search: {
        material_group_code: '',
        group_name: '',
        description: '',
      },
      searchMenu: '',
      apiUrl :config.apiUrl,

      totalOpen: '',
      totalInProgress: '',
      totalPending: '',
      totalClosed: '',
      backgroundRed: null,

      months: [],
      productionData: {},

      chartMonth: [],
      chartLineValue: [],

      emailTo: [],
      tableEmail: {
        data: [
          {email :'vinsensius.bobby@kffcorp.com'},
          {email :'robinand@daekyung.co.id'},
          {email :'muhaazir9@gmail.com'},
          {email :'swabiridha@gmail.com'},
          {email :'mokhamadbakri@gmail.com'},
          {email :'devaheksa@gmail.com'},
          {email :'Ichkwaneko.s@gmail.com'},
          {email :'laksmana31@gmail.com'},
          {email :'ahmadnasrullah574@gmail.com'},
          {email :'finance@tfesteel.id'},
        ]
      },

    };
  },
  mounted(){
    this.get();
    this.tokenApi = 'Bearer '+localStorage.getItem('token');
  },
  methods: {
    nameWithLang ({ project_number, project_name }) {
      return `${project_number} | ${project_name}`
    },
    get(param){
      let context = this;               
      Api(context, productionTimeline.index({material_group_code: this.search.material_group_code, group_name: this.search.group_name, description: this.search.description, page: context.pagination.page})).onSuccess(function(response) {    
          context.productionData = response.data.data.data;
          context.months         = response.data.data.months;

          context.chartMonth     = response.data.data.months;
          context.chartLineValue = response.data.data.chartLineValue;
          context.notify('Data Retrieved Successfully', 'success')
      }).onError(function(error) {                    
          if (error.response.status == 404) {
              context.table.data = [];
          }
          context.notify('Data Retrieved Failed', 'error')
      }).onFinish(function() { 
         context.formFilter.show  = false;
         context.onLoading = false; 
         context.getChart();
      })
      .call()
    },
    getChart(){
      this.getChartLine();
    },
    filter() {
      this.formFilter.add   = true;
      this.formFilter.show  = true;
      this.formFilter.title = "Filter";
      this.onLoading        = false;
      this.pagination.page  = 1 ;
    },
    create() {
      this.form.add          = true;
      this.form.show         = true;
      this.form.title        = "Add Data";
      this.timelineData = {};
    },
    edit(id) {
      let context = this;               
      Api(context, productionTimeline.show(id)).onSuccess(function(response) {
          context.timelineData = response.data.data;
          context.form.show         = true;
          context.form.title        = 'Edit Data';   
      })
      .call()        
    },
    save(){
      let api      = null;
      let context  = this;
      let formData = new FormData();
      context.onLoading = true;

      if (context.timelineData.client != undefined && context.timelineData.phase != undefined && context.timelineData.production_month  != undefined && context.timelineData.production_year  != undefined && context.timelineData.production_mt && context.timelineData.mark_color) {
        formData.append('client', context.timelineData.client);
        formData.append('phase', context.timelineData.phase);
        formData.append('production_month', context.timelineData.production_month );
        formData.append('production_year', context.timelineData.production_year );
        formData.append('production_mt', context.timelineData.production_mt);
        formData.append('mark_color', context.timelineData.mark_color);
        formData.append('emailTo', JSON.stringify(context.emailTo));
      }else{
        return alert('The Red Star Field is Mandatory')
      }

      if (context.form.title == 'Add Data') {
          api = Api(context, productionTimeline.create(formData));
      } else {
          api = Api(context, productionTimeline.update(this.timelineData.id, formData));
      }
      // eslint-disable-next-line no-unused-vars
      api.onSuccess(function(response) {
        context.get();
        context.form.show = false;
        context.notify((context.form === 'Add Data') ? 'Data Berhasil di Simpan' : 'Data Berhasil di Update', 'success')
      // eslint-disable-next-line no-unused-vars
      }).onError(function(error) { 
        context.notify((context.form != 'Add Data') ? 'Data Gagal di Simpan' : 'Data Gagal di Update', 'error')                   
      }).onFinish(function() { 
        context.onLoading = false; 
      })
      .call();
    },
    remove(id) {
      var r = confirm("Are you sure you want to delete this data ?");
      if (r == true) {
        let context = this;
        Api(context, productionTimeline.delete(id)).onSuccess(function(response) {
            context.get();
            context.notify('Data Successfully Deleted', 'success')
        }).call();
      }
    },
    getTotal(month) {
      let total = 0;
      for (const client in this.productionData) {
        for (const phase in this.productionData[client]) {
          let value = this.productionData[client][phase][month]?.[1];
          value = Number(value); // konversi string ke angka
          if (!isNaN(value)) {
            total += value;
          }
        }
      }
      return total.toFixed(1); // tetap 1 angka desimal
    },
    setBg(id) {
      this.backgroundRed = id
    },
    // CHART LINE
    getChartLine(){
      var ctx1 = document.getElementById("chart-line").getContext("2d");

      var gradientStroke1 = ctx1.createLinearGradient(0, 230, 0, 50);

      gradientStroke1.addColorStop(1, "rgba(94, 114, 228, 0.2)");
      gradientStroke1.addColorStop(0.2, "rgba(94, 114, 228, 0.0)");
      gradientStroke1.addColorStop(0, "rgba(94, 114, 228, 0)");

      new Chart(ctx1, {
        type: "line",
        data: {
          labels: Object.values(this.chartMonth),
          datasets: [
            {
              label: "Cost",
              tension: 0.4,
              borderWidth: 0,
              pointRadius: 0,
              borderColor: "#4BB543 ",
              backgroundColor: gradientStroke1,
              // eslint-disable-next-line no-dupe-keys
              borderWidth: 3,
              fill: true,
              data: Object.values(this.chartLineValue),
              maxBarThickness: 6,
            },
            // {
            //   label: "DB",
            //   tension: 0.4,
            //   borderWidth: 0,
            //   pointRadius: 0,
            //   borderColor: "#4BB543 ",
            //   backgroundColor: gradientStroke1,
            //   // eslint-disable-next-line no-dupe-keys
            //   borderWidth: 3,
            //   fill: true,
            //   data: [32,85,54,32],
            //   maxBarThickness: 6,
            // },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: false,
            },
          },
          interaction: {
            intersect: false,
            mode: "index",
          },
          scales: {
            y: {
              grid: {
                drawBorder: false,
                display: true,
                drawOnChartArea: true,
                drawTicks: false,
                borderDash: [5, 5],
              },
              ticks: {
                display: true,
                padding: 10,
                color: "#fbfbfb",
                font: {
                  size: 11,
                  family: "Open Sans",
                  style: "normal",
                  lineHeight: 2,
                },
              },
            },
            x: {
              grid: {
                drawBorder: false,
                display: false,
                drawOnChartArea: false,
                drawTicks: false,
                borderDash: [5, 5],
              },
              ticks: {
                display: true,
                color: "#ccc",
                padding: 20,
                font: {
                  size: 11,
                  family: "Open Sans",
                  style: "normal",
                  lineHeight: 2,
                },
              },
            },
          },
        },
      });

      // location.reload();
    },
    changePage(page){
      this.pagination.page = page;
      this.get();
    },
    notify(message, type) {
      if (type == 'success') {
        toast.success(message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 2000,
        }); // ToastOptions
      }else{
        toast.error(message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 2000,
        }); // ToastOptions
      }
    },

  }
};
</script>
<style scoped>
::v-deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;

}
::v-deep .modal-content {
  display: flex;
  flex-direction: column;
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  width: 500px;
  margin-top: auto;
  margin-bottom: auto;
}
.modal__title {
  font-size: 1rem;
  font-weight: 600;
}
</style>

<style scoped>
.dark-mode div::v-deep .modal-content {
  border-color: #2d3748;
  background-color: #1a202c;
}
.scroll { 
  overflow: auto; 
  height: 500px; 
}
.scroll thead th { 
  position: sticky; 
  top: 0; 
  z-index: 100; 
  background-color: #6495ED;
}
</style>
